import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function StatsSection() {
  const stats = [{
    icon: <Users className="w-8 h-8 mb-2 text-brand" data-id="element-325" />,
    value: '+500',
    label: 'Mujeres transformando'
  }, {
    icon: <BookOpen className="w-8 h-8 mb-2 text-brand" data-id="element-326" />,
    value: '6 Tomos',
    label: 'Listos para usar'
  }, {
    icon: <Gift className="w-8 h-8 mb-2 text-brand" data-id="element-327" />,
    value: '6 Bonos',
    label: 'Incluidos hoy'
  }, {
    icon: <Star className="w-8 h-8 mb-2 text-brand" data-id="element-328" />,
    value: '4.9/5',
    label: 'Calificación'
  }];
  return <section className="bg-white text-black py-12 border-y-4 border-brand" data-id="element-329">
      <div className="max-w-5xl mx-auto px-4" data-id="element-330">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-331">
          {stats.map((stat, i) => <div key={i} className="flex flex-col items-center justify-center p-4" data-id="element-332">
              {stat.icon}
              <div className="font-display font-black text-4xl mb-1" data-id="element-333">
                {stat.value}
              </div>
              <div className="text-gray-600 font-bold uppercase tracking-wide text-sm" data-id="element-334">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}